import styled from 'styled-components';
import {transparentize} from 'polished';
import {FavoriteCourseProps} from './types';

export const Wrapper = styled.div<FavoriteCourseProps>`
  display: ${({isToggle}) => isToggle ? 'grid' : 'inline-block'};
  grid-template-columns: min-content 1fr min-content;
  align-items: flex-start;
  column-gap: 6px;
  row-gap: 2px;

  border-radius: 6px;
  box-sizing: border-box;
  padding: 6px;
  margin: 5px 12px;
  background-color: ${({theme}) => `
    ${theme.variables.backgroundColor};
  `};
`;

export const Icon = styled.div`
  grid-row: span 2;
  width: 34px;
  height: 34px;
  border-radius: 6px;
  background-image: url("data:image/svg+xml,%3Csvg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='34' height='34' rx='6' fill='%233264EF'/%3E%3Cpath d='M8.13086 22.6315V16.7209C8.13086 15.7316 8.58309 14.7966 9.35862 14.1824L14.9901 9.72257C16.168 8.78974 17.8329 8.78974 19.0108 9.72258L24.6422 14.1824C25.4178 14.7966 25.87 15.7316 25.87 16.7209V22.6315C25.87 24.4199 24.4202 25.8696 22.6319 25.8696H11.369C9.5806 25.8696 8.13086 24.4199 8.13086 22.6315Z' stroke='white' stroke-width='1.5'/%3E%3C/svg%3E%0A");
`;

export const Label = styled.span`
  color: ${({theme}) => `
    ${transparentize(.6, theme.colors.white)};
  `};
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
`;

export const Title = styled.strong`
  grid-column-start: 2;
  grid-column: span 2;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const Button = styled.button`
  padding: 0;
  color: ${({theme}) => `
    ${theme.colors.primary};
  `};
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
`;
